module.exports = __webpack_public_path__ + "assets/img/00162.547c0e58.png";